export function keyTranslation(key) {
  switch (key) {
    case "fat":
      return "Fett";
    case "saturates":
      return "Gesättigte Fettsäuren";
    case "carbohydrate":
      return "Kohlenhydrate";
    case "sugars":
      return "Zucker";
    case "protein":
      return "Eiweiss";
    case "salt":
      return "Salz";
    default:
      return key;
  }
}

export const nutritionDetailsFields = {
  fat: "Fett",
  saturates: "Gesättigte Fettsäuren",
  carbohydrate: "Kohlenhydrate",
  sugars: "Zucker",
  protein: "Eiweiss",
  salt: "Salz",
};

export function parseRRULE(rruleStr) {
  const {
    INTERVAL = 1,
    BYDAY = null,
    COUNT = null,
    EXDATE = null,
  } = Object.fromEntries(
    rruleStr
      .replace("RRULE:", "")
      .split(";")
      .map((part) => part.split("=")),
  );

  const frequencyMatch = rruleStr.match(/FREQ=([A-Z]+)/);
  const frequency = frequencyMatch ? frequencyMatch[1] : null;

  return {
    frequency,
    interval: parseInt(INTERVAL, 10),
    byDay: BYDAY,
    count: parseInt(COUNT, 10),
    exDate: EXDATE,
    rruleStr,
  };
}

export function formatDeliveryDateIntl(date, timeframeShort, intl) {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return {};
  }

  // If the user's chosen locale is "en",
  // override it with "en-CA" to ensure date
  // format is YYYY-MM-DD.
  let dateFormatLocale = intl.locale;
  if (dateFormatLocale === "en") {
    dateFormatLocale = "en-CA";
  }

  const dateFormatter = new Intl.DateTimeFormat(dateFormatLocale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const formattedDate = dateFormatter.format(date);
  return { timeframeShort, formattedDate, _date: date };
}

export const calculateNextDeliveryDate = (
  currentDate,
  parsedRule,
  timeframeShort,
  dates,
  intl,
  excludeSold = true,
) => {
  const currentDateObj = new Date(currentDate);
  if (excludeSold) {
    dates = dates.filter((dateInfo) => !dateInfo.sold);
  }

  const selectedDates = dates
    .filter((dateInfo) => dateInfo.selected)
    .map((dateInfo) => new Date(dateInfo.date_iso_formatted))
    .sort((a, b) => a - b);

  let nextDate;

  if (selectedDates.length > 0) {
    nextDate = selectedDates[0];
  } else {
    // No selected dates
    // Find the last available (non-disabled) date
    const availableDates = dates
      .filter((dateInfo) => !dateInfo.disabled)
      .map((dateInfo) => new Date(dateInfo.date_iso_formatted))
      .sort((a, b) => a - b);

    if (availableDates.length > 0) {
      const lastAvailableDate = availableDates[availableDates.length - 1];
      nextDate = addIntervalToDate(lastAvailableDate, parsedRule);
    } else {
      // No available dates
      // Use currentDateObj and add the interval
      nextDate = addIntervalToDate(currentDateObj, parsedRule);
    }
  }

  return formatDeliveryDateIntl(nextDate, timeframeShort, intl);
};

function addIntervalToDate(date, parsedRule) {
  const newDate = new Date(date);
  if (parsedRule.frequency === "WEEKLY") {
    newDate.setDate(newDate.getDate() + parsedRule.interval * 7);
  } else if (parsedRule.frequency === "DAILY") {
    newDate.setDate(newDate.getDate() + parsedRule.interval);
  } else if (parsedRule.frequency === "MONTHLY") {
    newDate.setMonth(newDate.getMonth() + parsedRule.interval);
  }
  return newDate;
}
